var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"stats-card"},_vm._l((_vm.statsItems),function(item){return _c('div',{key:item.key,staticClass:"stat-item",class:item.type},[_c('i',{class:item.icon}),_c('span',{staticClass:"stat-label"},[_vm._v(_vm._s(item.label))]),_c('strong',{staticClass:"stat-value"},[_vm._v(_vm._s(_vm.formatNumber(item.value)))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }